import React from 'react';
import {Image} from '@/_application/core/components/ui/image';
import {ProductBadge} from '@/__generated__/__types__';
import { FetchPriority } from '@/_application/core/types';

interface IProps {
    badge: ProductBadge;
    isLCP?: boolean;
}

const ProductBadgeComponent: React.FC<IProps> = ({badge, isLCP = false}) => {
    if (!badge?.image) return null;

    return (
        <div className=" h-full w-full animate-slideFromLeft">
            <Image
                className="h-full w-full object-cover"
                src={badge?.image}
                width={100}
                height={50}
                alt="badge"
                priority={isLCP}
                fetchPriority={isLCP ? FetchPriority.HIGH : FetchPriority.AUTO}
            />
        </div>
    );
};

export default ProductBadgeComponent;
